import { supabase } from './supabase';

/**
 * LINE OA 加入狀態統一管理
 * 整合所有散落在各組件的不同 localStorage key
 */

const KEYS = [
  'line_oa_joined',
  'line_oa_friend_prompted',
  'blueshelter_bot_confirmed',
];

/** 檢查使用者是否已加入 LINE OA（任一 key 存在即視為已加入） */
export function isLineOaJoined(): boolean {
  return KEYS.some((k) => {
    const v = localStorage.getItem(k);
    return v === '1' || v === 'true';
  });
}

/** 標記已加入 LINE OA（同步設定所有 key，確保各頁面都知道，並寫入 DB） */
export async function markLineOaJoined(): Promise<void> {
  KEYS.forEach((k) => localStorage.setItem(k, '1'));

  // 若用戶已登入，同步寫入資料庫（用 upsert 確保無論有無記錄都能寫入）
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      await supabase
        .from('user_tokens')
        .upsert(
          {
            user_id: user.id,
            line_oa_joined: true,
            line_oa_joined_at: new Date().toISOString(),
          },
          { onConflict: 'user_id', ignoreDuplicates: false }
        );
    }
  } catch {
    // 寫入失敗不影響主流程
  }
}

/** 後台管理員手動設定用戶的 LINE OA 加入狀態 */
export async function adminSetLineOaJoined(userId: string, joined: boolean): Promise<void> {
  await supabase
    .from('user_tokens')
    .update({
      line_oa_joined: joined,
      line_oa_joined_at: joined ? new Date().toISOString() : null,
    })
    .eq('user_id', userId);
}
